export const USER_UNBLOCKED_EVENT = 'sb-user-unblocked';

export interface UserUnblockedEventDetail {
  userId: string;
}

export function notifyUserUnblocked(userId: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<UserUnblockedEventDetail>(USER_UNBLOCKED_EVENT, {
      detail: { userId },
    }),
  );
}
